<template>
  <div id="">
      <PageLoader />
      <NavBar />
      <HeaderBar />

    <!-- ============ TITLE START ============ -->
		<section id="title">
			<div class="container">
				<div class="row">
					<div class="col-sm-12 text-center">
						<h1>Candidates 2</h1>
						<h4>Find your perfect match</h4>
					</div>
				</div>
			</div>
		</section>

		<!-- ============ TITLE END ============ -->

        <!-- ============ JOBS START ============ -->
		<section id="jobs">
			<div class="container">
				<div class="row">
					<div class="col-sm-12">
						<h2>Candidates</h2>

						<div class="jobs">
							
							<!-- Candidate 1 -->
							<a href="#" class="featured">
								<div class="row">
									<div class="col-xs-3 col-sm-1">
										<img :src="`${baseUrl}/resources/placeholder/60x60.jpg`" alt="" class="img-circle img-responsive" />
									</div>
									<div class="col-xs-9 col-sm-4 candidate-name">
										<h5>Susie Johnson</h5>
										<p><strong>Project Manager</strong></p>
									</div>
									<div class="hidden-xs col-sm-4 candidate-location">
										<p><strong>New York City, NY, USA</strong></p>
										<p>743.6 mi away</p>
									</div>
									<div class="hidden-xs col-sm-3">
										<p class="candidate-date">Updated 3 weeks ago</p>
										<p class="candidate-tags">
											<span class="badge">Marketing</span>
											<span class="badge">Sale</span>
										</p>
									</div>
								</div>
							</a>
							
							<!-- Candidate 2 -->
							<a href="#" class="featured">
								<div class="row">
									<div class="col-xs-3 col-sm-1">
										<img :src="`${baseUrl}/resources/placeholder/60x60.jpg`" alt="" class="img-circle img-responsive" />
									</div>
									<div class="col-xs-9 col-sm-4 candidate-name">
										<h5>Matt Berry</h5>
										<p><strong>Senior Web Developer</strong></p>
									</div>
									<div class="hidden-xs col-sm-4 candidate-location">
										<p><strong>San Jose, CA, USA</strong></p>
										<p>743.6 mi away</p>
									</div>
									<div class="hidden-xs col-sm-3">
										<p class="candidate-date">Updated 2 weeks ago</p>
										<p class="candidate-tags">
											<span class="badge">IT</span>
											<span class="badge">Web development</span>
										</p>
									</div>
								</div>
							</a>
							
							<!-- Candidate 3 -->
							<a href="#">
								<div class="row">
									<div class="col-xs-3 col-sm-1">
										<img :src="`${baseUrl}/resources/placeholder/60x60.jpg`" alt="" class="img-circle img-responsive" />
									</div>
									<div class="col-xs-9 col-sm-4 candidate-name">
										<h5>Spencer Conner</h5>
										<p><strong>Front End Developer</strong></p>
									</div>
									<div class="hidden-xs col-sm-4 candidate-location">
										<p><strong>Seattle, WA, USA</strong></p>
										<p>743.6 mi away</p>
									</div>
									<div class="hidden-xs col-sm-3">
										<p class="candidate-date">Updated 1 week ago</p>
										<p class="candidate-tags">
											<span class="badge">IT</span>
											<span class="badge">Web development</span>
										</p>
									</div>
								</div>
							</a>
							
							<!-- Candidate 4 -->
							<a href="#">
								<div class="row">
									<div class="col-xs-3 col-sm-1">
										<img :src="`${baseUrl}/resources/placeholder/60x60.jpg`" alt="" class="img-circle img-responsive" />
									</div>
									<div class="col-xs-9 col-sm-4 candidate-name">
										<h5>Bernard Byrd</h5>
										<p><strong>Key Account Manager</strong></p>
									</div>
									<div class="hidden-xs col-sm-4 candidate-location">
										<p><strong>Los Angeles, CA, USA</strong></p>
										<p>743.6 mi away</p>
									</div>
									<div class="hidden-xs col-sm-3">
										<p class="candidate-date">Updated 5 days ago</p>
										<p class="candidate-tags">
											<span class="badge">Marketing</span>
											<span class="badge">Sales</span>
										</p>
									</div>
								</div>
							</a>
							
							<!-- Candidate 5 -->
							<a href="#">
								<div class="row">
									<div class="col-xs-3 col-sm-1">
										<img :src="`${baseUrl}/resources/placeholder/60x60.jpg`" alt="" class="img-circle img-responsive" />
									</div>
									<div class="col-xs-9 col-sm-4 candidate-name">
										<h5>Grace Bailey</h5>
										<p><strong>Sales Manager</strong></p>
									</div>
									<div class="hidden-xs col-sm-4 candidate-location">
										<p><strong>Chicago, IL, USA</strong></p>
										<p>743.6 mi away</p>
									</div>
									<div class="hidden-xs col-sm-3">
										<p class="candidate-date">Updated 5 days ago</p>
										<p class="candidate-tags">
											<span class="badge">Marketing</span>
											<span class="badge">Sales</span>
										</p>
									</div>
								</div>
							</a>
							
							<!-- Candidate 6 -->
							<a href="#">
								<div class="row">
									<div class="col-xs-3 col-sm-1">
										<img :src="`${baseUrl}/resources/placeholder/60x60.jpg`" alt="" class="img-circle img-responsive" />
									</div>
									<div class="col-xs-9 col-sm-4 candidate-name">
										<h5>Susie Johnson</h5>
										<p><strong>Project Manager</strong></p>
									</div>
									<div class="hidden-xs col-sm-4 candidate-location">
										<p><strong>New York City, NY, USA</strong></p>
										<p>743.6 mi away</p>
									</div>
									<div class="hidden-xs col-sm-3">
										<p class="candidate-date">Updated 3 weeks ago</p>
										<p class="candidate-tags">
											<span class="badge">Marketing</span>
											<span class="badge">Sale</span>
										</p>
									</div>
								</div>
							</a>
							
							<!-- Candidate 7 -->
							<a href="#">
								<div class="row">
									<div class="col-xs-3 col-sm-1">
										<img :src="`${baseUrl}/resources/placeholder/60x60.jpg`" alt="" class="img-circle img-responsive" />
									</div>
									<div class="col-xs-9 col-sm-4 candidate-name">
										<h5>Matt Berry</h5>
										<p><strong>Senior Web Developer</strong></p>
									</div>
									<div class="hidden-xs col-sm-4 candidate-location">
										<p><strong>San Jose, CA, USA</strong></p>
										<p>743.6 mi away</p>
									</div>
									<div class="hidden-xs col-sm-3">
										<p class="candidate-date">Updated 2 weeks ago</p>
										<p class="candidate-tags">
											<span class="badge">IT</span>
											<span class="badge">Web development</span>
										</p>
									</div>
								</div>
							</a>
							
							<!-- Candidate 8 -->
							<a href="#">
								<div class="row">
									<div class="col-xs-3 col-sm-1">
										<img :src="`${baseUrl}/resources/placeholder/60x60.jpg`" alt="" class="img-circle img-responsive" />
									</div>
									<div class="col-xs-9 col-sm-4 candidate-name">
										<h5>Spencer Conner</h5>
										<p><strong>Front End Developer</strong></p>
									</div>
									<div class="hidden-xs col-sm-4 candidate-location">
										<p><strong>Seattle, WA, USA</strong></p>
										<p>743.6 mi away</p>
									</div>
									<div class="hidden-xs col-sm-3">
										<p class="candidate-date">Updated 1 week ago</p>
										<p class="candidate-tags">
											<span class="badge">IT</span>
											<span class="badge">Web development</span>
										</p>
									</div>
								</div>
							</a>
							
							<!-- Candidate 9 -->
							<a href="#">
								<div class="row">
									<div class="col-xs-3 col-sm-1">
										<img :src="`${baseUrl}/resources/placeholder/60x60.jpg`" alt="" class="img-circle img-responsive" />
									</div>
									<div class="col-xs-9 col-sm-4 candidate-name">
										<h5>Bernard Byrd</h5>
										<p><strong>Key Account Manager</strong></p>
									</div>
									<div class="hidden-xs col-sm-4 candidate-location">
										<p><strong>Los Angeles, CA, USA</strong></p>
										<p>743.6 mi away</p>
									</div>
									<div class="hidden-xs col-sm-3">
										<p class="candidate-date">Updated 5 days ago</p>
										<p class="candidate-tags">
											<span class="badge">Marketing</span>
											<span class="badge">Sales</span>
										</p>
									</div>
								</div>
							</a>
							
							<!-- Candidate 10 -->
							<a href="#">
								<div class="row">
									<div class="col-xs-3 col-sm-1">
										<img :src="`${baseUrl}/resources/placeholder/60x60.jpg`" alt="" class="img-circle img-responsive" />
									</div>
									<div class="col-xs-9 col-sm-4 candidate-name">
										<h5>Grace Bailey</h5>
										<p><strong>Sales Manager</strong></p>
									</div>
									<div class="hidden-xs col-sm-4 candidate-location">
										<p><strong>Chicago, IL, USA</strong></p>
										<p>743.6 mi away</p>
									</div>
									<div class="hidden-xs col-sm-3">
										<p class="candidate-date">Updated 5 days ago</p>
										<p class="candidate-tags">
											<span class="badge">Marketing</span>
											<span class="badge">Sales</span>
										</p>
									</div>
								</div>
							</a>
							
							<!-- Candidate 11 -->
							<a href="#">
								<div class="row">
									<div class="col-xs-3 col-sm-1">
										<img :src="`${baseUrl}/resources/placeholder/60x60.jpg`" alt="" class="img-circle img-responsive" />
									</div>
									<div class="col-xs-9 col-sm-4 candidate-name">
										<h5>Susie Johnson</h5>
										<p><strong>Project Manager</strong></p>
									</div>
									<div class="hidden-xs col-sm-4 candidate-location">
										<p><strong>New York City, NY, USA</strong></p>
										<p>743.6 mi away</p>
									</div>
									<div class="hidden-xs col-sm-3">
										<p class="candidate-date">Updated 3 weeks ago</p>
										<p class="candidate-tags">
											<span class="badge">Marketing</span>
											<span class="badge">Sale</span>
										</p>
									</div>
								</div>
							</a>
							
							<!-- Candidate 12 -->
							<a href="#">
								<div class="row">
									<div class="col-xs-3 col-sm-1">
										<img :src="`${baseUrl}/resources/placeholder/60x60.jpg`" alt="" class="img-circle img-responsive" />
									</div>
									<div class="col-xs-9 col-sm-4 candidate-name">
										<h5>Matt Berry</h5>
										<p><strong>Senior Web Developer</strong></p>
									</div>
									<div class="hidden-xs col-sm-4 candidate-location">
										<p><strong>San Jose, CA, USA</strong></p>
										<p>743.6 mi away</p>
									</div>
									<div class="hidden-xs col-sm-3">
										<p class="candidate-date">Updated 2 weeks ago</p>
										<p class="candidate-tags">
											<span class="badge">IT</span>
											<span class="badge">Web development</span>
										</p>
									</div>
								</div>
							</a>
							
							<!-- Candidate 13 -->
							<a href="#">
								<div class="row">
									<div class="col-xs-3 col-sm-1">
										<img :src="`${baseUrl}/resources/placeholder/60x60.jpg`" alt="" class="img-circle img-responsive" />
									</div>
									<div class="col-xs-9 col-sm-4 candidate-name">
										<h5>Spencer Conner</h5>
										<p><strong>Front End Developer</strong></p>
									</div>
									<div class="hidden-xs col-sm-4 candidate-location">
										<p><strong>Seattle, WA, USA</strong></p>
										<p>743.6 mi away</p>
									</div>
									<div class="hidden-xs col-sm-3">
										<p class="candidate-date">Updated 1 week ago</p>
										<p class="candidate-tags">
											<span class="badge">IT</span>
											<span class="badge">Web development</span>
										</p>
									</div>
								</div>
							</a>
							
							<!-- Candidate 14 -->
							<a href="#">
								<div class="row">
									<div class="col-xs-3 col-sm-1">
										<img :src="`${baseUrl}/resources/placeholder/60x60.jpg`" alt="" class="img-circle img-responsive" />
									</div>
									<div class="col-xs-9 col-sm-4 candidate-name">
										<h5>Bernard Byrd</h5>
										<p><strong>Key Account Manager</strong></p>
									</div>
									<div class="hidden-xs col-sm-4 candidate-location">
										<p><strong>Los Angeles, CA, USA</strong></p>
										<p>743.6 mi away</p>
									</div>
									<div class="hidden-xs col-sm-3">
										<p class="candidate-date">Updated 5 days ago</p>
										<p class="candidate-tags">
											<span class="badge">Marketing</span>
											<span class="badge">Sales</span>
										</p>
									</div>
								</div>
							</a>
							
							<!-- Candidate 15 -->
							<a href="#">
								<div class="row">
									<div class="col-xs-3 col-sm-1">
										<img :src="`${baseUrl}/resources/placeholder/60x60.jpg`" alt="" class="img-circle img-responsive" />
									</div>
									<div class="col-xs-9 col-sm-4 candidate-name">
										<h5>Grace Bailey</h5>
										<p><strong>Sales Manager</strong></p>
									</div>
									<div class="hidden-xs col-sm-4 candidate-location">
										<p><strong>Chicago, IL, USA</strong></p>
										<p>743.6 mi away</p>
									</div>
									<div class="hidden-xs col-sm-3">
										<p class="candidate-date">Updated 5 days ago</p>
										<p class="candidate-tags">
											<span class="badge">Marketing</span>
											<span class="badge">Sales</span>
										</p>
									</div>
								</div>
							</a>
							
							<!-- Candidate 16 -->
							<a href="#">
								<div class="row">
									<div class="col-xs-3 col-sm-1">
										<img :src="`${baseUrl}/resources/placeholder/60x60.jpg`" alt="" class="img-circle img-responsive" />
									</div>
									<div class="col-xs-9 col-sm-4 candidate-name">
										<h5>Susie Johnson</h5>
										<p><strong>Project Manager</strong></p>
									</div>
									<div class="hidden-xs col-sm-4 candidate-location">
										<p><strong>New York City, NY, USA</strong></p>
										<p>743.6 mi away</p>
									</div>
									<div class="hidden-xs col-sm-3">
										<p class="candidate-date">Updated 3 weeks ago</p>
										<p class="candidate-tags">
											<span class="badge">Marketing</span>
											<span class="badge">Sale</span>
										</p>
									</div>
								</div>
							</a>
							
							<!-- Candidate 17 -->
							<a href="#">
								<div class="row">
									<div class="col-xs-3 col-sm-1">
										<img :src="`${baseUrl}/resources/placeholder/60x60.jpg`" alt="" class="img-circle img-responsive" />
									</div>
									<div class="col-xs-9 col-sm-4 candidate-name">
										<h5>Matt Berry</h5>
										<p><strong>Senior Web Developer</strong></p>
									</div>
									<div class="hidden-xs col-sm-4 candidate-location">
										<p><strong>San Jose, CA, USA</strong></p>
										<p>743.6 mi away</p>
									</div>
									<div class="hidden-xs col-sm-3">
										<p class="candidate-date">Updated 2 weeks ago</p>
										<p class="candidate-tags">
											<span class="badge">IT</span>
											<span class="badge">Web development</span>
										</p>
									</div>
								</div>
							</a>
							
							<!-- Candidate 18 -->
							<a href="#">
								<div class="row">
									<div class="col-xs-3 col-sm-1">
										<img :src="`${baseUrl}/resources/placeholder/60x60.jpg`" alt="" class="img-circle img-responsive" />
									</div>
									<div class="col-xs-9 col-sm-4 candidate-name">
										<h5>Spencer Conner</h5>
										<p><strong>Front End Developer</strong></p>
									</div>
									<div class="hidden-xs col-sm-4 candidate-location">
										<p><strong>Seattle, WA, USA</strong></p>
										<p>743.6 mi away</p>
									</div>
									<div class="hidden-xs col-sm-3">
										<p class="candidate-date">Updated 1 week ago</p>
										<p class="candidate-tags">
											<span class="badge">IT</span>
											<span class="badge">Web development</span>
										</p>
									</div>
								</div>
							</a>
							
							<!-- Candidate 19 -->
							<a href="#">
								<div class="row">
									<div class="col-xs-3 col-sm-1">
										<img :src="`${baseUrl}/resources/placeholder/60x60.jpg`" alt="" class="img-circle img-responsive" />
									</div>
									<div class="col-xs-9 col-sm-4 candidate-name">
										<h5>Bernard Byrd</h5>
										<p><strong>Key Account Manager</strong></p>
									</div>
									<div class="hidden-xs col-sm-4 candidate-location">
										<p><strong>Los Angeles, CA, USA</strong></p>
										<p>743.6 mi away</p>
									</div>
									<div class="hidden-xs col-sm-3">
										<p class="candidate-date">Updated 5 days ago</p>
										<p class="candidate-tags">
											<span class="badge">Marketing</span>
											<span class="badge">Sales</span>
										</p>
									</div>
								</div>
							</a>
							
							<!-- Candidate 20 -->
							<a href="#">
								<div class="row">
									<div class="col-xs-3 col-sm-1">
										<img :src="`${baseUrl}/resources/placeholder/60x60.jpg`" alt="" class="img-circle img-responsive" />
									</div>
									<div class="col-xs-9 col-sm-4 candidate-name">
										<h5>Grace Bailey</h5>
										<p><strong>Sales Manager</strong></p>
									</div>
									<div class="hidden-xs col-sm-4 candidate-location">
										<p><strong>Chicago, IL, USA</strong></p>
										<p>743.6 mi away</p>
									</div>
									<div class="hidden-xs col-sm-3">
										<p class="candidate-date">Updated 5 days ago</p>
										<p class="candidate-tags">
											<span class="badge">Marketing</span>
											<span class="badge">Sales</span>
										</p>
									</div>
								</div>
							</a>

						</div>

						<nav>
							<ul class="pagination">
								<li class="disabled"><a href="#" aria-label="Previous"><span aria-hidden="true">&laquo;</span></a></li>
								<li class="active"><a href="#">1 <span class="sr-only">(current)</span></a></li>
								<li><a href="#">2</a></li>
								<li><a href="#">3</a></li>
								<li><a href="#">4</a></li>
								<li><a href="#">5</a></li>
								<li><a href="#" aria-label="Next"><span aria-hidden="true">&raquo;</span></a></li>
							</ul>
						</nav>

					</div>
				</div>
			</div>
		</section>

		<!-- ============ JOBS END ============ -->

      <ContactsWrapper />      
      <FooterWrapper />
      <LoginPopup />
      <RegisterPopup />
  </div>
</template>

<script>
import PageLoader from '@/components/PageLoader.vue'
import NavBar from '@/components/NavBar.vue'
import HeaderBar from '@/components/HeaderBar.vue'
import ContactsWrapper from '@/components/ContactsWrapper.vue'
import FooterWrapper from '@/components/FooterWrapper.vue'
import LoginPopup from '@/components/LoginPopup.vue'
import RegisterPopup from "@/components/RegisterPopup.vue"
export default {
    components: {
        PageLoader,
        NavBar,
        HeaderBar,
        ContactsWrapper,        
        FooterWrapper,
        LoginPopup,
        RegisterPopup
    },
	data(){
		return{
			baseUrl: process.env.BASE_URL.replace(/\/$/, '')
		}
	},
	created(){
	let ckeditor = document.createElement('script');  
    ckeditor.setAttribute('src',"js/settings.js");
    document.head.appendChild(ckeditor);
  }
}
</script>

<style>

</style>